import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
// @ts-ignore
import { EXIF as exifShim } from 'exif-js/exif';
var EXIF = exifShim;
export class UploadWizardComponent {
    constructor(sanitizer, canDeactivateService, collectionService) {
        this.sanitizer = sanitizer;
        this.canDeactivateService = canDeactivateService;
        this.collectionService = collectionService;
        this.showValidation = false;
        this.close = new EventEmitter();
        this.photoUploaded = new EventEmitter();
    }
    get files() {
        return this._files;
    }
    set files(value) {
        this._files = value;
        this.setCurrentPhoto(0);
    }
    ngOnInit() {
    }
    isPhotoValid() {
        return this.photo.lat && this.photo.lon;
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.isPhotoValid()) {
                this.showValidation = true;
                return undefined;
            }
            let file = this._files[this.currentIndex];
            let photo = yield this.collectionService.uploadCollectionPhoto(file, this.collectionId, this.photo.lat, this.photo.lon);
            this.showValidation = false;
            return photo;
        });
    }
    saveAndNextPhoto() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.isPhotoValid()) {
                this.showValidation = true;
                return;
            }
            this.showValidation = false;
            let uploadedPhoto = yield this.save();
            if (!uploadedPhoto)
                return;
            this.photoUploaded.emit(uploadedPhoto);
            this.currentIndex++;
            if (this.currentIndex < this.files.length) {
                yield this.setCurrentPhoto(this.currentIndex);
            }
            else {
                this.closeWizard();
            }
        });
    }
    setCurrentPhoto(index) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.currentIndex = index;
            let file = this._files[index];
            const url = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
            let exifTags = yield this.extractExif(file);
            let photoLocation = this.convertExifToMapLocation(exifTags);
            let newPhoto = { originalUrl: url };
            if (photoLocation) {
                newPhoto = Object.assign({}, newPhoto, { lat: photoLocation.lat, lon: photoLocation.lng });
            }
            this.photo = newPhoto;
        });
    }
    extractExif(file) {
        return new Promise(resolve => {
            EXIF.getData(file, function () {
                resolve(EXIF.getAllTags(this));
            });
        });
    }
    convertExifToMapLocation(tags) {
        let latArray = tags.GPSLatitude;
        let lngArray = tags.GPSLongitude;
        let gpsLatitudeRef = tags.GPSLatitudeRef;
        let gpsLongitudeRef = tags.GPSLongitudeRef;
        if (!latArray || !lngArray || !gpsLatitudeRef || !gpsLongitudeRef)
            return null;
        let lat = this.convertExifFormatToDecimal(latArray, gpsLatitudeRef);
        let lng = this.convertExifFormatToDecimal(lngArray, gpsLongitudeRef);
        return { lat, lng };
    }
    convertExifFormatToDecimal(values, direction) {
        let degrees = values[0];
        let minutes = values[1];
        let seconds = values[2];
        let dd = degrees + (minutes / 60) + (seconds / 3600);
        if (direction == 'S' || direction == 'W') {
            dd = dd * -1;
        }
        //clip to 6 decimal places
        return +dd.toFixed(6);
    }
    closeWizard() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.close.emit();
        });
    }
    showConfirmLeaving() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let leaveThePage = yield this.canDeactivateService.showWarning();
            if (leaveThePage)
                this.closeWizard();
        });
    }
}
